import generateQuestionsFromFile from 'src/graphql/mutations/ai/generateQuestionsFromFile';

import post from './shared/post';

export default {
  generateQuestionsFromFile(values) {
    return post(values, generateQuestionsFromFile);
  },
};
